import { createRouter, createWebHistory } from "vue-router";
import { inject } from 'vue';
import { storeToRefs } from 'pinia'
import HomeIndex from "../components/sites/HomeIndex.vue";
import LoginIndex from "../components/sites/LoginIndex.vue";
import SupportIndex from "../components/sites/SupportIndex.vue";
import KlarvertragIndex from "../components/sites/KlarvertragIndex.vue";
import VertragIndex from "../components/sites/VertragIndex.vue";
import BrainIndex from "../components/sites/BrainIndex.vue";
import RechnungIndex from "../components/sites/RechnungIndex.vue";
import DokumenteIndex from "../components/sites/DokumenteIndex.vue";
import AdminIndex from "../components/sites/AdminIndex.vue";
import AdminSupportIndex from "../components/sites/AdminSupportIndex.vue";
import AdminSettings from "../components/sites/AdminSettings.vue";
import AdminAccount from "../components/sites/AdminAccount.vue";
import AdminKlarvertragIndex from "../components/sites/AdminKlarvertragIndex.vue";
import AdminMailTemplates from "../components/sites/AdminMailTemplates.vue";
import AdminUserDetail from "../components/sites/AdminUserDetail.vue";
import AdminCreateAdmin from "../components/sites/AdminCreateAdmin.vue";
import AdminCreateCustomer from "../components/sites/AdminCreateCustomer.vue";
import HelpIndex from "../components/sites/HelpIndex.vue";
import InfoImpressum from "../components/sites/InfoImpressum.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeIndex,
  },
  {
    path: "/vertrag/:id?",
    name: "vertrag",
    component: VertragIndex,
    meta: {
      requiresAuth: true,
      inlineAuth: true
    }
  },
  {
    path: "/dokumente/:id?",
    name: "dokumente",
    component: DokumenteIndex,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login/:token?",
    name: "login",
    component: LoginIndex,
  },
  {
    path: "/admin",
    name: "adminindex",
    component: AdminIndex,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/admin/support/:id",
    name: "adminsupport",
    component: AdminSupportIndex,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/admin/users/:id",
    name: "adminuserdetail",
    component: AdminUserDetail,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      inlineAuth: true
    }
  },
  {
    path: "/admin/create-admin",
    name: "admincreateadmin",
    component: AdminCreateAdmin,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: "/admin/create-customer",
    name: "admincreatecustomer",
    component: AdminCreateCustomer,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: "/admin/settings",
    name: "adminsettings",
    component: AdminSettings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/admin/account",
    name: "adminaccount",
    component: AdminAccount,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      inlineAuth: true
    }
  },
  {
    path: "/admin/klarvertrag",
    name: "adminklarvertrag",
    component: AdminKlarvertragIndex,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      inlineAuth: true
    }
  },
  {
    path: "/admin/mailtexte",
    name: "adminmailtemplates",
    component: AdminMailTemplates,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      requiresSuperAdmin: true
    }
  },
  {
    path: "/support/:id?/:token?",
    name: "support",
    component: SupportIndex,
    meta: {
      requiresAuth: true,
      inlineAuth: true
    }
  },
  {
    path: "/klarvertrag/:tarifId?",
    name: "klarvertrag",
    component: KlarvertragIndex,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/rechnung/:tarifId",
    name: "rechnung",
    component: RechnungIndex,
    meta: {
      requiresAuth: true,
      inlineAuth: true
    }
  },
  {
    path: "/brain/:productid?/:id?",
    name: "brain",
    component: BrainIndex,
    meta: {
      requiresAuth: true,
      inlineAuth: true
    }
  },
  {
    path: "/hilft/:id?",
    name: "help",
    component: HelpIndex,
    meta: {
      requiresAuth: true,
      requiresCustomer: true,
      inlineAuth: true
    }
  },
  {
    path: "/info/Impressum",
    name: "info-impressum",
    component: InfoImpressum
  },


  // {
  //   // GESCHÜTZTE ROUTE: Benutzerprofil
  //   path: '/profile',
  //   name: 'Profile',
  //   component: Profile,
  //   meta: {
  //     requiresAuth: true
  //   }
  // }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const userStore = inject('userStore');
  
  if (!userStore) {
    console.error('userStore is not available');
    next();
    return;
  }

  const { userData } = storeToRefs(userStore);
  const currentUser = userData.value;
  const requiresAuth = to.meta.requiresAuth;
  const requiresCustomer = to.meta.requiresCustomer;
  const requiresAdmin = to.meta.requiresAdmin;
  const inlineAuth = to.meta.inlineAuth;
  const requiresSuperAdmin = to.meta.requiresSuperAdmin;
  const hasSupportToken = to.name === 'support' && Boolean(to.params?.token);

  if (requiresAuth && !currentUser && !inlineAuth && !hasSupportToken) {
    next({ path: "/login" });
    return;
  }

  if (hasSupportToken && currentUser) {
    next({
      name: 'support',
      params: { id: to.params?.id },
      replace: true
    });
    return;
  }

  if (requiresCustomer && currentUser && Number(currentUser.user_admin) !== 0) {
      next({ path: "/admin" });
      return;
    }

  if (requiresAdmin) {
    if (!currentUser) {
      if (!inlineAuth) {
        next({ path: "/login" });
        return;
      }
    } else if (Number(currentUser.user_admin) !== 1) {
      next({ path: "/" });
      return;
    }
  }

  if (requiresSuperAdmin) {
    if (!currentUser) {
      next({ path: "/login" });
      return;
    }
    if (Number(currentUser.user_super_admin ?? 0) !== 1) {
      next({ path: "/admin" });
      return;
    }
  }

  next();
});
export default router;
